import { TYPES_PAYMENT } from 'www/vue_components/common/Club/constants'

export * from './constantsFamilyProfiles'

export const MOUNT_ID_APPOINTMENT = 'appointment-page'

export const USER_ACTION_AFTER_AUTH = {
  sendAppointmentForm: 'sendAppointmentForm',
}

export const RECURSIVE_INTERVAL_SCHEDULE_CHECKS_DOCTOR_MS = 60 * 1000

export const APPOINTMENT_ERRORS = {
  defaultTryAgain: {
    title: 'Не получилось записаться',
    subtitle: 'Обновите страницу и попробуйте ещё раз.',
    buttonState: {
      get: 'reload',
      post: 'closeAndReload',
    },
  },
  appointmentNotAvailable: {
    title: 'По выбранным параметрам уже не получится записаться',
    subtitle: 'Подобрали для вас другие варианты в этой же клинике. Проверьте, подходят ли вам врач и оборудование.',
    buttonState: {
      get: 'understandWithReload',
      post: 'understandWithReload',
    },
  },
  appointmentNotAvailableByAge: {
    title: 'Нет специалистов, принимающих пациентов вашего возраста',
    subtitle: 'Выберите другую клинику',
    buttonState: {
      get: 'selectPatientOrOtherLpu',
      post: 'selectPatientOrOtherLpu',
    },
  },
  notNetwork: {
    title: 'Нет соединения с интернетом',
    subtitle: 'Проверьте соединение и попробуйте снова.',
    buttonState: {
      get: 'understandWithReload',
      post: 'understandWithReload',
    },
  },
  appointmentDateNotAvailable: {
    subtitle: 'Нет доступного времени для записи',
  },
  notAuthorization: {
    title: 'Войдите в свой профиль, чтобы продолжить',
    buttonState: {
      get: 'loginHowPatient',
      post: 'loginHowPatient',
    },
  },
  appointmentPreliminaryConsultationNotAvailable: {
    title: 'По выбранным параметрам уже не получится записаться',
    subtitle: 'Подобрали для вас другие варианты в этой же клинике.',
    buttonState: {
      get: 'understand',
      post: 'understand',
    },
  },
  slotsIsOver: {
    title: 'Закончилось время в расписании',
    subtitle: 'Можно выбрать другую клинику.',
    buttonState: {
      get: 'selectOtherLpu',
      post: 'selectOtherLpu',
    },
  },
  dataIsOutDate: {
    title: 'Данные на странице устарели',
    buttonState: {
      get: 'reloadDoctorCalendar',
      post: 'reloadDoctorCalendar',
    },
  },
  appointmentDoctorOnlineNotWork: {
    title: 'У клиники временно не работает онлайн-запись',
    buttonState: {
      get: 'toDoctor',
      post: 'toDoctor',
    },
  },
  appointmentServiceOnlineNotWork: {
    title: 'У клиники временно не работает система для онлайн-записи',
    subtitle: 'Запишитесь в другую клинику.',
    buttonState: {
      get: 'toLpuServiceList',
      post: 'toLpuServiceList',
    },
  },
}

export const APPOINTMENT_SUCCESSES = {
  defaultSuccess: {
    title: 'Вы записаны на приём',
    subtitle: 'Мы отправили вам СМС с деталями записи.',
  },
}

export const APPOINTMENT_TYPE_NAMES = {
  direct: 'direct',
  express: 'express',
}

export const APPOINTMENT_TYPE_LABELS = {
  [APPOINTMENT_TYPE_NAMES.direct]: 'Онлайн-запись',
  [APPOINTMENT_TYPE_NAMES.express]: 'Экспресс-запись',
}

export const PAYMENT_TYPES = {
  club: TYPES_PAYMENT.online,
  lpu: TYPES_PAYMENT.offline,
}

export const NEW_APPOINTMENT_URLS = {
  service: '/ajax/appointment/service/new/',
  doctor: '/ajax/appointment/doctor/new/',
}

export const APPOINTMENT_PLACE_TYPES = {
  home: 'na_dom',
  online: 'online',
  telemed: 'telemed',
  club: 'club',
  telemedMedtochka: 'telemed_mt',
}

const FORM_CHECKBOXES_DATA = {
  isMissingStimulant: {
    label: 'У меня не установлен кардио-\n или нейростимулятор',
    dataQA: 'appointment_form_has_stimulant_checkbox',
  },
  isMissingMetal: {
    label: 'В моем организме нет\n предметов из металла',
    dataQA: 'appointment_form_has_metal_checkbox',
  },
}

export const FORM_CHECKBOXES_OF_CLASSES = {
  mrt: [FORM_CHECKBOXES_DATA.isMissingStimulant, FORM_CHECKBOXES_DATA.isMissingMetal],
}

/**
 * Перед редиректом в МедТочку необходимо отображать текст в прелоадере минимум 4 сек. (*решение дизайнера)
 */
export const PRELOADER_DELAY_FOR_TELEMED_MS = 4000

export const AGE_OF_MAJORITY = 18

export const AGE_OF_GETTING_PASSPORT = 14

export const DELAY_UNTIL_SKELETONS_DISAPPEAR = 300
